import {
  IconCalendarTime,
  IconChevronLeft,
  IconChevronRight,
  IconListDetails,
  IconReload,
  IconSearch,
} from '@tabler/icons-react';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { DateRange } from 'react-date-range';
import moment from 'moment';
import { DinamicTitle } from '../../utils/DinamicTitle';
import Input from '../../components/Input';
import useKarat from '../features/useKarat';
import useCabang from '../features/useCabang';
import DetailBarangPenjualan from '../Transaksi/DetailBarangPenjualan';

function EtalaseKeluar() {
  const navigate = useNavigate();

  const [trxPenjualan, setTrxPenjualan] = useState([]);
  const [kategori, setKategori] = useState([]);
  const [selectedKategori, setSelectedKategori] = useState('');
  const [selectJenisKategori, setSelectJenisKategori] = useState('');
  const { cabang } = useCabang();
  const [idCabang, setIdCabang] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const awal = moment(startDate).format('DD-MM-YYYY');
  const akhir = moment(endDate).format('DD-MM-YYYY');

  const { karatOption, karatOptionId, setKaratOptionId } = useKarat();
  const [filterBerat, setFilterBerat] = useState('');
  const [berat, setBerat] = useState('');

  const [search, setSearch] = useState('');
  const [scanInput, setScanInput] = useState('');
  const searchInputRef = useRef(null);
  const scanTimeoutRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState('1');
  const [lastPage, setLastPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState('');
  const startIndex = (currentPage - 1) * (itemsPerPage || 10);
  
  const [totalBarang, setTotalBarang] = useState(0);
  const [totalBerat, setTotalBerat] = useState(0);
  const [totalHarga, setTotalHarga] = useState(0);

  let [isOpen, setIsOpen] = useState(false);
  const [detailPenjualan, setDetailPenjualan] = useState([]);

  function closeModal() {
    setIsOpen(false);
  }

  function showDetailPenjualan(item) {
    setDetailPenjualan(item);
    setIsOpen(true);
  }

  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: 'selection',
  };

  function handleSelect(date) {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  }

  function numberWithCommas(x) {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
  }

  function checkBerat(number) {
    const beratConfirm = parseFloat(number);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
          .toFixed(2)
          .replace(/\.?0+$/, '')
          .replace('.', ',');
  }

  const filterBeratBarang = () => {
    setBerat(filterBerat);
  };

  function refreshPage() {
    window.location.reload(false);
  }

  async function getKategori() {
    await http
      .get('/kategori', {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setKategori(res.data);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/login');
        }
      });
  }

  useEffect(() => {
    getKategori();
  }, [navigate]);

  const handleKategoriChange = (event) => {
    setSelectedKategori(event.target.value);
    setSelectJenisKategori('');
  };

  const handleJenisKategoriChange = (event) => {
    setSelectJenisKategori(event.target.value);
  };

  async function getTrxPenjualan() {
    setLoading(true);
    await http
      .get(
        `penjualan${search === '' ? `?page=${currentPage}` : `?faktur=${search}`}${
          (idCabang === 0 || idCabang === '') ? `` : `&cabang=${idCabang}`
        }${(selectedKategori === 0 || selectedKategori === '') ? `` : `&kategori=${selectedKategori}`}${
          (selectJenisKategori === 0 || selectJenisKategori === '') ? `` : `&jenis_kategori=${selectJenisKategori}`
        }${startDate === null && endDate === null ? `` : `&tgl_awal=${awal}&tgl_akhir=${akhir}`}${
          karatOptionId === '' ? '' : `&karat=${karatOptionId}`
        }${berat === '' ? '' : `&berat=${berat}`}&is_refund=0`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      )
      .then((res) => {
        setTrxPenjualan(res.data.data.data);
        setCurrentPage(res.data.data.current_page);
        setItemsPerPage(res.data.data.per_page);
        setLastPage(res.data.data.last_page);
        setTotalBarang(res.data.data.total);
        
        // Calculate page totals dynamically
        const pageData = res.data.data.data;
        const pageTotalBerat = pageData.reduce((acc, curr) => acc + (parseFloat(curr.item?.berat) || 0), 0);
        const pageTotalHarga = pageData.reduce((acc, curr) => acc + (parseFloat(curr.total_harga) || 0), 0);
        setTotalBerat(pageTotalBerat);
        setTotalHarga(pageTotalHarga);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate('/login');
        }
      });
    setLoading(false);
  }

  useEffect(() => {
    getTrxPenjualan();
  }, [
    idCabang,
    selectedKategori,
    selectJenisKategori,
    search.length >= 12 ? search : '',
    awal,
    akhir,
    startDate,
    endDate,
    currentPage,
    karatOptionId,
    berat,
  ]);

  useEffect(() => {
    setPageInput(currentPage.toString());
  }, [currentPage]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };

  const jumpToPage = () => {
    const pageNumber = parseInt(pageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= lastPage) {
      setCurrentPage(pageNumber);
    } else {
      setPageInput(currentPage.toString());
    }
  };

  const handlePageInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      jumpToPage();
      e.target.blur();
    }
  };

  function nextPage() {
    setCurrentPage(currentPage + 1);
  }

  function prevPage() {
    setCurrentPage(currentPage - 1);
  }

  useEffect(() => {
    if (scanInput.length >= 10) {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
      scanTimeoutRef.current = setTimeout(() => {
        setSearch(scanInput);
      }, 300);
    }
    return () => {
      if (scanTimeoutRef.current) clearTimeout(scanTimeoutRef.current);
    };
  }, [scanInput]);

  DinamicTitle('Etalase Keluar || Komaladewi');

  return (
    <Layouts
      dateFilter={`${awal === 'Invalid date' ? '' : ` ${awal}`} ${awal === akhir ? `` : `${akhir === 'Invalid date' ? '' : ` s/d ${akhir}`}`}`}
      compFilter={
        <div className="flex items-center gap-1.5">
          <div className="dropdown dropdown-bottom">
            <div
              tabIndex={0}
              className="bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-500 hover:to-amber-600 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
            >
              <IconCalendarTime size={20} />
            </div>
            <div tabIndex={0} className="dropdown-content menu -right-52 p-2 shadow-xl bg-white dark:bg-slate-800 rounded-xl border dark:border-slate-700 z-50">
              <DateRange ranges={[selectionRange]} onChange={handleSelect} />
            </div>
          </div>
          <button
            onClick={refreshPage}
            className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-sm hover:shadow transition-all duration-200"
          >
            <IconReload size={20} />
          </button>
          <div className="relative group hidden sm:flex">
            <IconSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors" />
            <Input
              ref={searchInputRef}
              value={scanInput}
              onChange={(e) => {
                setScanInput(e.target.value);
                if (e.target.value.length < 10) {
                  setSearch(e.target.value);
                }
              }}
              className="px-3 py-2 text-left input input-bordered w-[160px] lg:w-[220px] rounded-lg pl-9 bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 dark:text-slate-200 hover:border-amber-300 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 text-sm shadow-sm transition-all outline-none"
              autoComplete="off"
              type="search"
              name="search"
              placeholder="Scan / Cari Faktur"
            />
          </div>
        </div>
      }
    >
      <DetailBarangPenjualan
        label={'Detail Penjualan Keluar'}
        checkBerat={checkBerat}
        closeModal={closeModal}
        detailPenjualan={detailPenjualan}
        isOpen={isOpen}
      />
      {/* ═══ Filter Bar ═══ */}
      <div className="bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border-b border-amber-100/60 dark:border-slate-700/60 px-3 py-2.5 transition-colors">
        <div className="flex items-center gap-2 w-full overflow-x-auto scrollbar-none">
          <div className="flex items-center gap-1.5 flex-shrink-0">
            {/* Cabang */}
            <select
              onChange={(e) => setIdCabang(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Semua Etalase</option>
              {cabang.map((cb) => (
                <option value={cb.id} key={cb.id}>
                  {cb.nama_cabang}
                </option>
              ))}
            </select>

            {/* Kategori */}
            <select
              value={selectedKategori}
              onChange={handleKategoriChange}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Kategori</option>
              {kategori.map((kt) => (
                <option key={kt.id} value={kt.id}>
                  {kt.nama_kategori}
                </option>
              ))}
            </select>

            {/* Jenis Kategori */}
            {selectedKategori && (
              <select
                onChange={handleJenisKategoriChange}
                value={selectJenisKategori}
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
              >
                <option value="">Jenis Kategori</option>
                {kategori
                  .find((kt) => kt.id === parseInt(selectedKategori))
                  ?.jenis_kategori.map((jk) => (
                    <option key={jk.id} value={jk.id}>
                      {jk.nama_jenis}
                    </option>
                  ))}
              </select>
            )}

            {/* Karat */}
            <select
              onChange={(e) => setKaratOptionId(e.target.value)}
              className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none"
            >
              <option value="">Karat</option>
              {karatOption.map((kto) => (
                <option value={kto} key={kto}>{kto}</option>
              ))}
            </select>

            {/* Berat Search */}
            <div className="flex items-center gap-1 w-44">
              <Input
                onChange={(e) => setFilterBerat(e.target.value)}
                placeholder="Cari Berat"
                className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none w-full"
              />
              <button
                onClick={filterBeratBarang}
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 p-2 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 flex-shrink-0"
              >
                <IconSearch size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ═══ Data Table ═══ */}
      <div className="flex-1 flex flex-col">
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <div className="flex flex-col items-center gap-3">
              <div className="w-10 h-10 border-3 border-amber-200 dark:border-amber-800 border-t-amber-500 dark:border-t-amber-400 rounded-full animate-spin"></div>
              <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
            </div>
          </div>
        ) : (
          <div className="relative overflow-x-auto overflow-hidden mx-3 mt-3 mb-4 rounded-xl border border-slate-200/60 dark:border-slate-700/60 shadow-sm">
            <table className="w-full text-sm text-left dark:text-slate-300">
              <thead>
                <tr className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30">
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">No</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Kode Barang</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Nama Barang</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Berat | Karat</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Harga</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Rata | Gram</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Kasir</th>
                  <th scope="col" className="px-4 py-3 text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider whitespace-nowrap text-left">Tanggal Transfer</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700 bg-white dark:bg-slate-900">
                {trxPenjualan?.length > 0 ? (
                  trxPenjualan.map((trx, i) => (
                    <tr
                      key={trx.id}
                      onClick={() => showDetailPenjualan(trx)}
                      className="hover:bg-amber-50/50 dark:hover:bg-slate-700/30 cursor-pointer transition-colors"
                    >
                      <td className="px-4 py-3 text-slate-700 dark:text-slate-300">{startIndex + i + 1}.</td>
                      <td className="px-4 py-3 whitespace-nowrap font-semibold text-amber-700 dark:text-amber-500">
                        {trx?.item?.kode_item}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-slate-700 dark:text-slate-300">
                        {trx?.item?.jenis_kategori?.nama_jenis}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-slate-700 dark:text-slate-300">
                        <span className="font-semibold text-slate-800 dark:text-slate-200">{trx?.item?.berat} gr</span>{' '}
                        <span className="text-slate-400 dark:text-slate-500">| {trx?.item?.karat} krt</span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-slate-800 dark:text-slate-200 font-medium">
                        Rp {numberWithCommas(trx.total_harga || 0)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-slate-800 dark:text-slate-200">
                        Rp {numberWithCommas(trx.total_harga && trx.item?.berat ? Math.round(trx.total_harga / trx.item?.berat) : 0)}
                        <span className="text-slate-400 dark:text-slate-500 text-xs ml-1">/ gr</span>
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-slate-700 dark:text-slate-300">
                        {trx?.user?.name}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-slate-700 dark:text-slate-300">
                        {trx.created_at}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="px-4 py-8 text-center text-slate-500 dark:text-slate-400">
                      Tidak ada data ditemukan
                    </td>
                  </tr>
                )}
              </tbody>
              {trxPenjualan?.length > 0 && (
                <tfoot className="bg-amber-50/50 dark:bg-slate-800/80 border-t border-amber-200/60 dark:border-slate-700/60 font-semibold text-amber-900 dark:text-amber-100">
                  <tr>
                    <td colSpan="3" className="px-4 py-3 text-right">Total Halaman Ini:</td>
                    <td className="px-4 py-3 whitespace-nowrap">{parseFloat(totalBerat).toFixed(3)} gr</td>
                    <td className="px-4 py-3 whitespace-nowrap">Rp {numberWithCommas(totalHarga)}</td>
                    <td colSpan="3" className="px-4 py-3"></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        )}

        {/* ═══ Footer: Summary + Pagination ═══ */}
        <div className="bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm bottom-0 left-0 py-2.5 px-4 w-full absolute border-t border-amber-100/60 dark:border-slate-700/60 transition-colors">
          <div className="flex items-center justify-between">
            {/* Desktop Summary */}
            <div className="lg:flex hidden items-center gap-5">
              <div className="flex items-center gap-2 bg-gradient-to-r from-amber-50 to-amber-100/50 dark:from-slate-800 dark:to-slate-800/50 rounded-lg px-3.5 py-2 border border-amber-200/40 dark:border-slate-700">
                <span className="text-xs font-semibold text-amber-700 dark:text-amber-400 uppercase tracking-wide">Total Barang</span>
                <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{totalBarang}</span>
              </div>
            </div>

            {/* Mobile Summary */}
            <div className="dropdown dropdown-top lg:hidden">
              <div
                tabIndex={0}
                className="bg-gradient-to-r from-amber-500 to-amber-600 cursor-pointer hover:from-amber-600 hover:to-amber-700 hover:shadow-md p-2 text-white rounded-lg shadow-sm transition-all duration-200"
              >
                <IconListDetails size={20} />
              </div>
              <div tabIndex={0} className="dropdown-content menu p-4 shadow-xl bg-white dark:bg-slate-800 rounded-xl w-[250px] border border-amber-100 dark:border-slate-700">
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-amber-700 dark:text-amber-400 uppercase">Total Barang</span>
                    <span className="text-sm font-bold text-slate-800 dark:text-slate-200">{totalBarang} item</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Pagination */}
            <div className="flex items-center gap-2.5">
              <span className="text-xs font-medium text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                Halaman
                <input
                  type="text"
                  value={pageInput}
                  onChange={handlePageInputChange}
                  onBlur={jumpToPage}
                  onKeyDown={handlePageInputKeyDown}
                  className="w-12 h-7 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-400 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                />
                dari <span className="font-bold text-amber-700 dark:text-amber-400">{lastPage}</span>
              </span>
              <div className="flex items-center gap-1">
                <button
                  onClick={prevPage}
                  disabled={currentPage < 2}
                  title="previous"
                  type="button"
                  className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <IconChevronLeft size={16} />
                </button>
                <button
                  onClick={nextPage}
                  disabled={currentPage >= lastPage}
                  title="next"
                  type="button"
                  className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                >
                  <IconChevronRight size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
}

export default EtalaseKeluar;
